module.exports = __webpack_public_path__ + "static/media/factura autorizacion.424342cc.ico";